import React, { ReactElement, useEffect, useRef, useState } from 'react'

export interface DropdownTypes {
  dropdownOpened: boolean
  closeDropdown: () => void
  openDropdown: () => void
  toggleDropdown: () => void
  nodeRef: any
}

interface DropdownProps {
  children: ({
    dropdownOpened,
    closeDropdown,
    openDropdown,
    toggleDropdown,
    nodeRef,
  }: DropdownTypes) => ReactElement<{}>
  onClickOutside?: () => void
  shouldCloseOnOutside?: boolean
}

export const Dropdown: React.FunctionComponent<DropdownProps> = ({
  children,
  onClickOutside = () => undefined,
  shouldCloseOnOutside = true,
}) => {
  const [dropdownOpened, setDropdownState] = useState(false)
  const nodeRef: any = useRef(null)

  useEffect(() => {
    const handleClick = (e: Event) => {
      if (nodeRef.current.contains(e.target)) {
        // inside click
        return
      }
      // outside click
      if (shouldCloseOnOutside) {
        onClickOutside()
        setDropdownState(false)
      }
    }
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [onClickOutside, shouldCloseOnOutside])

  const toggleDropdown = () => {
    setDropdownState(!dropdownOpened)
  }

  const closeDropdown = () => {
    setDropdownState(false)
  }

  const openDropdown = () => {
    setDropdownState(true)
  }

  return children({
    dropdownOpened,
    closeDropdown,
    openDropdown,
    toggleDropdown,
    nodeRef,
  })
}

export default Dropdown
